import { useQuery } from "@tanstack/react-query";

import { api } from "../lib/api";

/** Mostra se a API (e o banco, pelo /health) está no ar. Ajuda a testar cada ambiente. */
export function ApiStatus() {
  const health = useQuery({
    queryKey: ["health"],
    queryFn: async () => {
      const { data, response } = await api.GET("/health");
      // 503 também traz o corpo (banco fora do ar); erro de rede cai no isError.
      return { ok: response.ok, data };
    },
    retry: false,
    refetchInterval: 60_000,
  });

  let dot = "bg-line";
  let text = "Verificando a API…";
  if (health.isError) {
    dot = "bg-[#8c2f2f]";
    text = "API fora do ar";
  } else if (health.data) {
    const { ok, data } = health.data;
    dot = ok ? "bg-[#3f7a4f]" : "bg-[#b07a2a]";
    text = ok ? "API ok" : "API no ar, banco fora";
    if (data) text += ` · ${data.environment} · ${data.version}`;
  }

  return (
    <p role="status" className="flex items-center justify-center gap-2 text-[13px] text-muted">
      <span aria-hidden className={`inline-block size-2 rounded-full ${dot}`} />
      {text}
    </p>
  );
}
